import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import bg1 from '../../assets/images/b1.png'

export default class Tours extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }

    render() {
        return (
            <div>
                <div className="pageHeader" style={{ backgroundImage: `url(${bg1})` }}>
                    <h1>Walking Tours</h1>
                </div>
                <h2>Welcome to A Poetry Mile: Poetry Walking Tours!</h2>
                <p>A Poetry Mile is a project by Push the Boat Out: Edinburgh’s International Poetry Festival. We’ve put together a wonderful selection of poets who have written specially commissioned poems about, in, or inspired by Edinburgh spaces on a wide range of topics. This web app will conjure up a special poetry tour just for you so you can introduce yourself to some fantastic Edi poets on a stroll. </p>
                <p>If you’d like to know more about how the app works, click on our About section. Otherwise, select an option below and we'll make a route for you around Edinburgh to start your adventure. </p>
                <Row>
                    <NavLink className="button" activeStyle={this.style} to="/quickwalk">Take Me On a Random Walk!</NavLink>
                </Row>
                <br />
                <Row>
                    <NavLink className="button" activeStyle={this.style} to="/themedwalk"> I’d like to choose a themed walk!</NavLink>
                </Row>
                <br />
                <Row>
                    <NavLink className="button" activeStyle={this.style} to="/curatedwalk">I’d like to choose a curated walk!</NavLink>
                </Row>
            </div>
        );
    }
}
